import {skipToken} from '@reduxjs/toolkit/query';

import {isNil, isNotNil} from 'ramda';

import {useGetCustomerV2Query} from '@dms/api/customer';
import {TelephonyCall} from '@dms/api/settings';
import {getCustomerName} from '@dms/shared';

/**
 * The call's customer by name. `customerName` is only the match of the caller's number; a customer
 * the call took from a paired record comes as `customerId` alone, so its name is read here.
 */
export function useCallCustomerName(call: TelephonyCall) {
  const unnamedCustomerId = isNil(call.customerName) ? call.customerId : null;
  const {data: customer} = useGetCustomerV2Query(
    isNotNil(unnamedCustomerId) ? {customerId: unnamedCustomerId} : skipToken
  );

  return call.customerName ?? getCustomerName(customer) ?? null;
}
